import useGetGlobalSearchPipelineItems from '../../controllers/GlobalSearchContentController/apis/useGetGlobalSearchPipelineItems'
import useGetOpenSearchPipelineItems from '../getOpenSearchPipelineItems/useGetOpenSearchPipelineItems'

const useSearchPipelineItemsAPIHookWrapper = (
   shouldCallOpenSearch: boolean
) => {
   const openSearchData = useGetOpenSearchPipelineItems()
   const globalSearchData = useGetGlobalSearchPipelineItems()

   if (shouldCallOpenSearch) {
      const {
         triggerAPI,
         apiStatus,
         apiError,
         fetchMore,
         searchResults,
         totalCount
      } = openSearchData
      return {
         triggerAPI,
         apiStatus,
         apiError,
         fetchMore,
         searchResults,
         totalCount
      }
   }
   const {
      triggerAPI,
      apiStatus,
      apiError,
      fetchMore,
      searchResults,
      totalCount
   } = globalSearchData

   return {
      triggerAPI,
      apiStatus,
      apiError,
      fetchMore,
      searchResults,
      totalCount
   }
}

export default useSearchPipelineItemsAPIHookWrapper
